module.exports = __webpack_public_path__ + "img/Result_Best_0608_01.127cc9ed.png";